import { __awaiter, __generator } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Checkbox, FormControl, InputLabel, MenuItem, Select, } from "@mui/material";
import { useEffect, useState } from "react";
import { renderChipList } from "./renderChipList";
import { CustomText } from "@corporate-trip-planner-fe/ui-styles";
function DropdownField(_a) {
    var _this = this;
    var fieldInfo = _a.fieldInfo, formik = _a.formik;
    var _b = useState([]), fieldOptions = _b[0], setFieldOptions = _b[1];
    var fieldName = fieldInfo.name;
    var showError = function () {
        return formik.touched[fieldName] && formik.errors[fieldName] ? true : false;
    };
    var handleChange = function (e) {
        var value = e.target.value;
        if (fieldInfo.multiple) {
            var selectedValues_1 = Array.isArray(value)
                ? value
                : [value];
            var newFormikValue = fieldOptions.filter(function (option) {
                return selectedValues_1.includes(option.value);
            });
            // Ensure always an array
            formik.setFieldValue(fieldName, newFormikValue);
        }
        else {
            formik.setFieldValue(fieldName, String(value));
        }
    };
    console.log("fieldInfo: ", fieldInfo, ", formik.values.fieldName: ", formik.values[fieldName]);
    var formikFieldValue = fieldInfo.multiple
        ? Array.isArray(formik.values[fieldName])
            ? formik.values[fieldName].map(function (item) { return item.value; })
            : []
        : formik.values[fieldName]
            ? String(formik.values[fieldName])
            : "";
    var getSelectedChipsLabel = function (selected) {
        if (!Array.isArray(selected))
            return [];
        return selected
            .map(function (value) {
            var option = fieldOptions.find(function (opt) { return opt.value === value; });
            return option ? option.label : value;
        })
            .filter(Boolean); // remove any undefined/null
    };
    useEffect(function () {
        var resolveOptions = function () { return __awaiter(_this, void 0, void 0, function () {
            var options, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        options = [];
                        if (!Array.isArray(fieldInfo.options)) return [3 /*break*/, 1];
                        options = fieldInfo.options;
                        return [3 /*break*/, 4];
                    case 1:
                        if (!(typeof fieldInfo.options === "function")) return [3 /*break*/, 4];
                        result = fieldInfo.options();
                        if (!(result instanceof Promise)) return [3 /*break*/, 3];
                        return [4 /*yield*/, result];
                    case 2:
                        options = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        options = result;
                        _a.label = 4;
                    case 4:
                        setFieldOptions(options);
                        return [2 /*return*/];
                }
            });
        }); };
        resolveOptions();
    }, [fieldInfo.options]);
    return (_jsxs(FormControl, { fullWidth: true, className: "my-2", disabled: formik.isSubmitting, children: [_jsx(InputLabel, { id: fieldName, children: fieldInfo.label }), _jsx(Select, { labelId: "".concat(fieldName, "-label"), name: fieldName, value: formikFieldValue, multiple: fieldInfo.multiple || false, onChange: handleChange, error: showError(), size: "small", renderValue: function (selected) {
                    return Array.isArray(selected)
                        ? renderChipList(getSelectedChipsLabel(selected), 3)
                        : selected;
                }, MenuProps: {
                    PaperProps: {
                        style: {
                            maxHeight: "50vh",
                        },
                    },
                }, children: fieldOptions === null || fieldOptions === void 0 ? void 0 : fieldOptions.map(function (option) { return (_jsxs(MenuItem, { value: option.value, children: [fieldInfo.multiple && (_jsx(Checkbox, { checked: formikFieldValue.includes(option.value) })), _jsx(CustomText, { children: option.label })] }, option.value)); }) })] }));
}
export default DropdownField;
